import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { APP_ASSETS_SVG_RAINFOREST } from "libraries/svgPaths";

type Props = {
  textVisible: boolean;
};

const MapRainforestFoundationPanel = ({ textVisible }: Props) => {
  return (
    <Box
      sx={{
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: { xs: "flex-start", sm: "center" },
        py: { xs: 0, sm: 2 },
        px: { xs: 0, sm: 2 },
        background: "transparent",
      }}
    >
      <Box
        component="img"
        src={APP_ASSETS_SVG_RAINFOREST}
        alt="Rainforest Foundation Norway"
        sx={{
          width: { xs: 170, sm: 220, md: 260 },
          height: "auto",
          objectFit: "contain",
          filter:
            "brightness(0) invert(1) drop-shadow(0px 4px 12px rgba(0,0,0,0.6))",
          mb: { xs: 1, sm: 2 },
        }}
      />
      <Stack
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={0}
        sx={{
          opacity: textVisible ? 1 : 0,
          transition: "opacity 1.5s ease",
          width: { xs: "calc(100vw - 32px)", sm: "max-content" },
          maxWidth: { xs: "calc(100vw - 32px)", sm: "90vw" },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: "white",
            fontWeight: 900,
            fontSize: { xs: "clamp(0.56rem, 3.1vw, 0.86rem)", sm: "1.2rem", md: "1.5rem" },
            textTransform: "uppercase",
            letterSpacing: { xs: 0.5, sm: 1.5, md: 2 },
            textAlign: { xs: "left", sm: "center" },
            lineHeight: 1.2,
            whiteSpace: "nowrap",
          }}
        >
          WELCOME TO THE FORECO (FOREST ECONOMY) PROJECT
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: "rgba(255,255,255,0.95)",
            fontWeight: 700,
            fontSize: { xs: "clamp(0.48rem, 2.5vw, 0.72rem)", sm: "0.95rem", md: "1.1rem" },
            letterSpacing: { xs: 0.4, sm: 1 },
            textAlign: { xs: "left", sm: "center" },
            mt: 0.5,
            whiteSpace: "nowrap",
          }}
        >
          WE MAKE SUSTAINABLE FOREST ECONOMIES IN THE RAINFOREST POSSIBLE
        </Typography>
      </Stack>
    </Box>
  );
};
export default MapRainforestFoundationPanel;
